import React, { useState, useContext, useEffect } from 'react';
import PropTypes from 'prop-types';

import { AuthContext } from 'context/AuthContext';

import LoginForm from './LoginForm';
import { Redirect } from 'react-router-dom';
import { PasswordResetRequest } from '.';
import { useBasePath } from 'hooks';

const Login = ({ history }) => {
  const [loggingIn, setLoggingIn] = useState(false);
  const { p } = useBasePath();
  const { login, sessionValid, authError: contextError } = useContext(AuthContext);
  const [authError, setAuthError] = useState();
  const [resetPage, setResetPage] = useState(undefined);

  /**
   * This effect will set the authentication error if the AuthContext has an error.
   *
   * @param {string} contextError error that resulted from the AuthContext - usually these are fatal or misconfigurations.
   */
  useEffect(() => {
    if (contextError) {
      setAuthError(contextError);
    }
  }, [contextError]);

  if (window.location.search.includes('register=true') && resetPage === undefined) {
    setResetPage(PageState.Register);
  }

  const onSubmit = async (form) => {
    setLoggingIn(true);
    let lowercaseEmailUsername = form.username;
    lowercaseEmailUsername = lowercaseEmailUsername.toLowerCase();
    const response = await login(lowercaseEmailUsername, form.password);
    try {
      if (response.authCode) {
        history.push(p('/'));
      } else {
        setLoggingIn(false);
        setAuthError(response.error);
      }
    } catch (err) {
      setLoggingIn(false);
      setAuthError(err);
    }
  };

  if (resetPage === PageState.Forgot) {
    return <PasswordResetRequest />;
  } else if (resetPage === PageState.Register) {
    return <Redirect to="/register" />;
  } else if (sessionValid && !loggingIn) {
    return <Redirect to="/" />;
  } else {
    return (
      <LoginForm
        onSubmit={onSubmit}
        authError={authError}
        loggingIn={loggingIn}
        gotoForgot={() => setResetPage(PageState.Forgot)}
        gotoRegister={() => setResetPage(PageState.Register)}
      />
    );
  }
};

const PageState = {
  Login: 0,
  Forgot: 1,
  Register: 2,
};

Login.propTypes = {
  history: PropTypes.object,
};

Login.defaultProps = {
  history: undefined,
};

export default Login;
